module.exports = __webpack_public_path__ + "media/images/game/who_can_join/best_team-ad3e789397fded401c9cf5b7eb87d4e8.png";